import { Component, Injectable } from '@angular/core';
import { DispatcherModule } from '../../store/dispatcher.module';
import { NgRedux } from '@angular-redux/store';
import { AppState } from '../../store/state.model';
import { AdminActions } from './admin-actions';

@Injectable({
  providedIn: DispatcherModule,
})
export class AdminDispatcher {
  /**
  * @require ngRedux Redux
  * @require azureService MSAL azure library
  **/
  constructor(
    private ngRedux: NgRedux<AppState>
  ) { }

  /**
  * @functions setUpdateInfo Store the update info
  * @param dealer code
  * @param email User email
  * @param Name User prefered name
  * @return void
  **/
  public setUpdateInfo(UpdateType: string, updateAttribute: string, updateValue: string, updatedDate: string, otherParams?: object) {
    this.ngRedux.dispatch(AdminActions.setUpdateInfo(UpdateType, updateAttribute, updateValue, updatedDate, otherParams));
  }
  /**
  * @method resetUpdate reset the update info
  * @return void
  **/
  public resetUpdate(): void {
    this.ngRedux.dispatch(AdminActions.resetUpdate());
  }

}
